module.exports = __webpack_public_path__ + "static/media/ChristmasCard.530c2fef.jpg";